import React from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

const VIDEO_STARTED_CLASS = 'vjs-has-started'

class Brightcove extends React.Component {
  componentDidMount() {
    this.attachSourceScript()
  }

  attachSourceScript = () => {
    const script = document.createElement("script")
    script.src = this.getScriptSource(this.props.item.link_url)
    script.async = true
    script.onload = this.disableAutoPlay
    this.embedWrapper.appendChild(script)
  }

  disableAutoPlay = () => {
    const player = videojs.default.getPlayer('myPlayerID')

    player.on('loadedmetadata', () => {
      player.pause()
      player.removeClass(VIDEO_STARTED_CLASS)
    })
    player.on('play', () => player.addClass(VIDEO_STARTED_CLASS))
  }

  getScriptSource = (videoUrl) => {
    return `${videoUrl.split('.html')[0]}.js`
  }

  parseParamsFromUrl = (url) => {
    const uri = new URL(url)
    const urlParts = uri.pathname.split('/')

    return {
      dataAccount: urlParts[1],
      dataPlayer: urlParts[2].replace('_default', ''),
      videoId: uri.searchParams.get("videoId")
    }
  }

  render() {
    const params = this.parseParamsFromUrl(this.props.item.link_url)
    const dataAccount = params.dataAccount
    const dataPlayer = params.dataPlayer
    const videoId = params.videoId

    return (
      <div className="brightcove-container" ref={ref => this.embedWrapper = ref}>
        <video-js
          id="myPlayerID"
          data-video-id={videoId}
          data-account={dataAccount}
          data-player={dataPlayer}
          data-embed="default"
          data-application-id=""
          class="vjs-fluid"
          controls="" />
      </div>
     )
  }
}

Brightcove.propTypes = {
  item: PropTypes.object.isRequired
}

export default Brightcove
